import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "postFilter" })
export class PostFilter implements PipeTransform {
  transform(
    array: any[],
    active: boolean,
    projectFilter: string,
    nationalityFilter: string,
    employerFilter: string,
    countryFilter: string
  ): any[] {
    if (array) {
      return array.filter((post) => {
        let result = true;
        result = !active || post.active || false;
        if (result) {
          if (projectFilter && projectFilter !== "undefined") {
            result =
              post.context.project_ids.filter((id) => {
                return id === projectFilter;
              }).length > 0;
          }
          if (result) {
            if (nationalityFilter && nationalityFilter !== "undefined") {
              result =
                post.context.nationalities.filter((id) => {
                  return id === nationalityFilter;
                }).length > 0;
            }
            if (result) {
              if (employerFilter && employerFilter !== "undefined") {
                result =
                  post.context.employer_ids.filter((id) => {
                    return id === employerFilter;
                  }).length > 0;
              }
              if (result) {
                if (countryFilter && countryFilter !== "undefined") {
                  result =
                    (post.context.countries || []).filter((id) => {
                      return id === countryFilter;
                    }).length > 0;
                }
              }
            }
          }
        }
        return result;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/posts/posts.filter.ts